import axios from 'axios-jsonp-pro';
import qs from 'qs';
const NODE_ENV = process.env.NODE_ENV;

const http = axios.create({
	baseURL:
		NODE_ENV === 'production' ? '//zptopic.58.com' : '//hapi.58corp.com',
	timeout: 10000,
	changeOrigin: true,
	withCredentials: true
});

// 添加一个请求拦截器
http.interceptors.request.use(
	function (config) {
		// 在发送请求之前做些什么
		return config;
	},
	function (error) {
		// 对请求错误做些什么
		return Promise.reject(error);
	}
);

// 添加一个响应拦截器
http.interceptors.response.use(
	function (response) {
		// 对响应数据做点什么
		return response.data;
	},
	function (error) {
		// 对响应错误做点什么
		return Promise.reject(error);
	}
);

const get = async (url, data, apiId) => {
	if (NODE_ENV === 'development') {
		data.mock_apiId = apiId;
	}
	return http.get(url, {
		params: data
	});
};

const post = (url, data, apiId) => {
	if (NODE_ENV === 'development') {
		data.mock_apiId = apiId;
	}
	return http.post(url, qs.stringify(data), {
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		}
	});
};

const jsonp = (url, data, apiId) => {
	if (NODE_ENV === 'development') {
		data.mock_apiId = apiId;
	}
	return axios.jsonp(url, {
		timeout: 10000,
		params: data
	});
};

export default {
	get,
	post,
	http,
	jsonp
};
